import React from 'react';
import { BookOpen, Download, Gift, Sparkles } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-6 pb-8 md:pt-24 md:pb-28 overflow-hidden px-4 sm:px-6 lg:px-8" data-id="element-124">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[700px] bg-purple-600/15 blur-[120px] rounded-full pointer-events-none hidden md:block" data-id="element-125" />
      <div className="absolute top-40 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-blue-600/10 blur-[100px] rounded-full pointer-events-none hidden md:block" data-id="element-126" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-127">
        {/* Brand Tag */}
        <div className="hero-animate-1 inline-flex items-center gap-2 px-4 py-1.5 md:px-5 md:py-2 rounded-full bg-purple-500/10 border border-purple-500/30 text-purple-300 font-semibold text-xs md:text-sm tracking-widest mb-4 md:mb-8 uppercase shadow-[0_0_15px_rgba(168,85,247,0.15)]" data-id="element-128">
          👨‍👩‍👧‍👦 PACK 100 CITAS
        </div>

        {/* Main Headline */}
        <h1 className="hero-animate-2 text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[1.08] tracking-tight mb-2 md:mb-4 text-white" data-id="element-129">
          Menos pantallas, más abrazos: descubrí el poder del{' '}
          <span className="text-gradient-cosmic" data-id="element-130">Pack 100 Citas</span>
        </h1>

        {/* Accent Subheadline */}
        <p className="hero-animate-2 text-2xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-purple-400 mb-6 md:mb-12" data-id="element-131">
          Jugá. Conectá. Recordá.
        </p>

        {/* Product Image */}
        <div className="relative max-w-xs md:max-w-2xl mx-auto mb-6 md:mb-12" data-id="element-132">
          <div className="absolute inset-0 bg-gradient-to-tr from-purple-600/20 via-blue-500/10 to-gold-500/10 blur-3xl rounded-full scale-110 hidden md:block" data-id="element-133" />
          <img src="https://cdn.magicpatterns.com/uploads/2nFdrEaPiVub8xhAi43svN/100_citas_mejor.jpg" alt="Pack 100 Citas Familiares" className="relative z-10 w-full h-auto drop-shadow-2xl" width={672} height={672} loading="eager" decoding="async" fetchPriority="high" data-id="element-134" />
        </div>

        {/* Product Description */}
        <div className="hero-animate-3 max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-135">
          <h2 className="text-base md:text-2xl font-bold text-purple-300 mb-2 md:mb-3" data-id="element-136">
            Descubre el Pack 100 Citas 👨‍👩‍👧‍👦 y vive experiencias únicas con tus
            hijos y toda la familia.
          </h2>
          <p className="text-sm md:text-lg text-slate-400 leading-relaxed" data-id="element-137">
            Cada cita 💫 es un momento especial que fortalece los lazos,
            despierta sonrisas y crea recuerdos para siempre ❤️
          </p>
        </div>

        {/* Trust Badges */}
        <div className="hero-animate-4 flex flex-wrap items-center justify-center gap-1.5 md:gap-3 mb-6 md:mb-10" data-id="element-138">
          {[{
          icon: BookOpen,
          label: '4 Libros digitales'
        }, {
          icon: Download,
          label: 'Descarga inmediata'
        }, {
          icon: Gift,
          label: '7 Bonos incluidos'
        }, {
          icon: Sparkles,
          label: '+500 ideas'
        }].map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-xl bg-navy-800/80 border border-navy-700 text-xs md:text-sm font-medium text-slate-300 backdrop-blur-sm" data-id="element-139">
              <badge.icon className="w-4 h-4 text-purple-400" data-id="element-140" />
              {badge.label}
            </span>)}
        </div>

        {/* CTA Button */}
        <div className="hero-animate-5 flex flex-col items-center w-full md:w-auto" data-id="element-141">
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-bold text-sm md:text-lg py-3 px-6 md:py-4 md:px-10 rounded-full shadow-[0_0_30px_rgba(168,85,247,0.4)] transition-all transform hover:scale-[1.03] flex items-center justify-center gap-2 w-full md:w-auto border border-purple-400/30" data-id="element-142">
            👉 SÍ, QUIERO LA OFERTA AHORA
          </button>

          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-5 mt-4 md:mt-5 text-[10px] md:text-sm text-slate-500" data-id="element-143">
            <span data-id="element-144">🛡️ Garantía 7 días</span>
            <span className="text-slate-700" data-id="element-145">•</span>
            <span data-id="element-146">🔒 Pago seguro</span>
            <span className="text-slate-700" data-id="element-147">•</span>
            <span data-id="element-148">💳 Mercado Pago | Tarjeta</span>
          </div>
        </div>
      </div>
    </section>;
}